import React, { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import {
  Heading,
  Icon,
  LinkButton,
  LoadingIndicator,
  Stack,
} from '@eluve/components';
import { TabNav } from '@eluve/smart-blocks';

const evalRoutes = [
  { name: 'Source Artifact Review', link: 'source-artifact-review' },
];
export const EvalLayout: React.FC = () => {
  return (
    <div className="min-h-full">
      <div className="bg-text-primary pb-32">
        <header className="py-4 lg:py-8">
          <div className="mx-auto w-full px-2 lg:px-8">
            <Stack
              className="gap-y-2"
              direction="horizontal"
              wrap
              align="center"
              justify="between"
            >
              <Stack
                direction="horizontal"
                align="center"
                gap={2}
                fullWidth={false}
              >
                <Icon
                  name="FlaskConical"
                  size="xl"
                  className="size-10 text-border-yellow-subtle"
                />
                <Heading
                  size="3xl"
                  weight="bold"
                  level={1}
                  className="tracking-tight text-white"
                >
                  Eluve Eval Dashboard
                </Heading>
              </Stack>
              <Stack
                className="md:gap-2"
                direction="horizontal"
                wrap
                gap={1}
                align="stretch"
              >
                <LinkButton variant="secondary" to="/">
                  <Icon name="LogOut" size="auto" />
                  Return to App
                </LinkButton>
              </Stack>
            </Stack>
            <div className="mt-4">
              <TabNav tabs={evalRoutes} colorMode="dark" />
            </div>
          </div>
        </header>
      </div>

      <main className="-mt-32">
        <div className="mx-auto w-full px-2 pb-12 lg:px-8">
          <div className="min-h-96 rounded-lg bg-white px-5 py-6 shadow-sm sm:px-6">
            <div className="w-full">
              <Suspense fallback={<LoadingIndicator size="xl" />}>
                <Outlet />
              </Suspense>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};
